"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContents = void 0;
const utils_1 = require("./utils");
const getClient_1 = require("./utils/getClient");
const transformObjectToRemoveFields_1 = require("./utils/transformObjectToRemoveFields");
/**
 * Get content for a page from contentful including all the metadata
 */
const getContents = async ({ space, accessToken, host, contentType, locale, environment, trackingApplicationName, fields }) => {
    const client = (0, getClient_1.getClient)({ space, accessToken, host, environment });
    const content = await client
        .getEntries(Object.assign({ content_type: contentType, locale, limit: 1000, include: 10 }, fields))
        .catch((error) => {
        throw new Error(`error in fetching contents, ${error}`);
    });
    void (0, utils_1.trackData)(content, trackingApplicationName, space !== null && space !== void 0 ? space : '');
    return content.items.map((item) => (0, transformObjectToRemoveFields_1.transformObjectToRemoveFields)(item));
};
exports.getContents = getContents;
//# sourceMappingURL=getContents.js.map